import { AfterViewInit, Component, Input, OnDestroy, OnInit, OnChanges } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Counter } from 'orv-ui-base-lib';
import { orderBy, cloneDeep } from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-bar-chart',
	templateUrl: './bar-chart.component.html',
	styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

	@Input() id: string = '';
	@Input() datas: Counter[];
	@Input() limit: number = 10;
	@Input() height: number = 200;

	ordereddata: any;
	total: number = 0;
	more: boolean = false;
	chart: any;

	viewInitialized = false;

	constructor(private translateService: TranslateService) {
	}

	ngOnInit() {
	}

	ngOnChanges() {
		if (this.datas && this.datas.length && this.viewInitialized) {
			this.initChart();
		}
	}

	ngAfterViewInit() {
		this.viewInitialized = true;
		if (this.datas && this.datas.length) {
			this.initChart();
		}
	}

	ngOnDestroy() {
		if (this.chart) {
			this.chart.dispose();
		}
	}

	initChart() {
		setTimeout(() => this.createChart());
	}

	createChart() {
		if (this.chart) {
			this.chart.dispose();
		} else {
			am4core.useTheme(am4themes_animated);
		}

		// Create chart instance
		this.chart = am4core.create(this.id, am4charts.XYChart);

		this.chart.preloader.disabled = true;

		const categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.dataFields.category = 'label';
		categoryAxis.renderer.minGridDistance = 1;
		categoryAxis.renderer.inversed = true;
		categoryAxis.renderer.grid.template.disabled = true;

		const valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
		valueAxis.min = 0;

		const series = this.chart.series.push(new am4charts.ColumnSeries());
		series.dataFields.categoryY = 'label';
		series.dataFields.valueX = 'ct';
		series.columns.template.tooltipText = '{ct}';
		series.columns.template.strokeOpacity = 0;
		series.columns.template.column.cornerRadiusBottomRight = 5;
		series.columns.template.column.cornerRadiusTopRight = 5;

		const labelBullet = series.bullets.push(new am4charts.LabelBullet());
		labelBullet.label.horizontalCenter = 'left';
		labelBullet.label.dx = 10;
		labelBullet.label.text = '{datas.valueX.workingValue.formatNumber(\'#.###,##\')}';
		labelBullet.locationX = 1;

		/*
		series.columns.template.adapter.add('fill', (fill, target) => {
			return this.chart.colors.getIndex(target.dataItem.index);
		});
		*/

		this.ordereddata = orderBy(this.datas, 'ct', 'desc');

		const otherlabel = this.translateService.instant('labels.other');
		const other = { label: otherlabel, ct: 0 };
		for (let index = 0; index < this.ordereddata.length; index++) {
			const element = this.ordereddata[index];
			if (index > this.limit) {
				other.ct = other.ct + element.value;
			}
			this.total = this.total + element.value;
		}

		if (this.datas.length > this.limit) {
			this.chart.data = cloneDeep(this.ordereddata.slice(0, this.limit));
			this.chart.data.push(other);
		} else {
			this.chart.data = this.ordereddata;
		}
	}
}
